import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { SelectField } from '../components/Table/fields/SelectField';
import { NamedEntityWithSalesPartner } from '../types/entities/NamedEntityWithSalesPartner';
import { salesPartner } from './salesPartner';

const makeEnumItem = (
  name: string,
  url: string,
  pluralName?: string
): SchemaWithClient<NamedEntityWithSalesPartner> => {
  return {
    name,
    pluralName: (pluralName === '' ? `${name}s` : pluralName) || `${name}s`,
    columns: {
      name: {
        name: 'Name',
        required: true,
        fieldRenderer: TextField,
        fieldType: 'text',
      },
      sales_partner: {
        name: 'Sales Partner',
        fieldRenderer: SelectField.tableAdapter(salesPartner),
        switchboard: true,
        url: salesPartner.client.getAllPath,
        tempSchema: salesPartner,
      },
      id: {
        name: 'ID',
        required: true,
        fieldRenderer: NumberField,
        fieldType: 'number',
        readOnly: true,
      },
    },
    client: new Client('/enums' + url),
  };
};

export const enumItemsWithSalesPartner = {
  bookingAgent: makeEnumItem('Booking Agent', '/booking-agents'),
};
